var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useCallback, useEffect } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { localCache } from '../localMessagsCache';
import { handleEventsFromLivePerson } from './handleLivePersonMessage';
import { submitMessageToLivePerson } from './submitLivePersonMessage';
import { EVENT_TYPE, MESSAGE_TYPE } from './constantsLivePerson';
import { handleCloseEvent } from './handleCloseEvent';
let livePersonEventSource;
export const useLivePersonConnectionRequest = ({
  chatMessages,
  setChatMessages,
  setIsDisablingInputValue,
  setLivePersonAgentInitial,
  setLivePersonAgentName,
  setStreamingText,
  setErrorMessage,
  lpUserFirstName,
  lpUserLastName,
  setCachedMessages,
  setLivePersonConversationId,
  livePersonOptions = {},
  isLivePersonEnabled,
  setIsLivePersonEnabled,
  livePersonConversationId,
  chatSummary,
  isLivePersonSessionActive,
  setIsLivePersonSessionActive,
  closeLpChat,
  setCloseLpChat,
  livePersonAgentName
}) => {
  const syncLivePersonChatMessage = () => {
    setChatMessages([...localCache.getLocalMessages()]);
  };
  const {
    submitMessageURL,
    livePersonEventSubscriptionURL,
    handleLivePersonOnMessageError,
    productId,
    chatCustomerId,
    initiateAgentlog
  } = livePersonOptions;
  useEffect(() => {
    const requestOptions = {
      url: submitMessageURL,
      headers: {}
    };
    const user = {
      firstName: lpUserFirstName,
      lastName: lpUserLastName
    };
    if (closeLpChat && livePersonConversationId && isLivePersonSessionActive) {
      submitMessageToLivePerson({
        requestOptions,
        livePersonMessagePayload: {
          chatCustomerId,
          user,
          lpData: {
            messageType: MESSAGE_TYPE.CLOSE,
            conversationId: livePersonConversationId
          },
          msgId: uuidV4()
        },
        handleLivePersonOnMessageError
      });
      handleCloseEvent({
        livePersonAgentNickname: livePersonAgentName,
        setIsLivePersonSessionActive,
        setIsLivePersonEnabled,
        setCloseLpChat,
        livePersonEventSource,
        setLivePersonAgentName,
        setLivePersonAgentInitial,
        setStreamingText,
        setCachedMessages,
        syncChatMessage: syncLivePersonChatMessage,
        setLivePersonConversationId
      });
    } else if (chatSummary && livePersonConversationId && !closeLpChat && isLivePersonSessionActive) {
      const baseLpData = {
        messageType: MESSAGE_TYPE.MESSAGE,
        conversationId: livePersonConversationId,
        eventType: EVENT_TYPE.ContentEvent
      };
      // Submit chatSummary to LP service, so the agent knows the previous conversation
      submitMessageToLivePerson({
        requestOptions,
        livePersonMessagePayload: {
          chatCustomerId,
          user,
          lpData: Object.assign(Object.assign({}, baseLpData), {
            eventDesc: `Previous conversation summary with bot: ${chatSummary}`,
            type: 'SUMMARY'
          }),
          msgId: uuidV4()
        },
        handleLivePersonOnMessageError
      });
      submitMessageToLivePerson({
        requestOptions,
        livePersonMessagePayload: {
          chatCustomerId,
          user,
          lpData: Object.assign(Object.assign({}, baseLpData), {
            eventDesc: JSON.stringify(localCache.getLocalPrompts()),
            type: 'TRANSCRIPT'
          }),
          msgId: uuidV4()
        },
        handleLivePersonOnMessageError
      });
    }
  }, [livePersonConversationId, chatSummary, isLivePersonSessionActive, closeLpChat]);
  return useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    if (isLivePersonEnabled && lpUserFirstName && lpUserLastName && !isLivePersonSessionActive) {
      setIsLivePersonSessionActive(true);
      setIsDisablingInputValue(true);
      // Subscrible to live person service to get SSE
      const subscriptionURL = `${livePersonEventSubscriptionURL}?chatCustomerId=${chatCustomerId}`;
      if (livePersonEventSource) {
        const oldSource = livePersonEventSource;
        oldSource.close();
      }
      livePersonEventSource = new EventSource(subscriptionURL);
      const eventSourceOptions = {
        livePersonEventSource,
        handleLivePersonOnMessageError,
        syncChatMessage: syncLivePersonChatMessage,
        setLivePersonAgentInitial,
        setLivePersonAgentName,
        setLivePersonConversationId,
        setCachedMessages,
        setStreamingText,
        setErrorMessage,
        lpUserFirstName,
        lpUserLastName,
        chatCustomerId,
        submitMessageURL,
        setIsLivePersonEnabled,
        setIsLivePersonSessionActive,
        setCloseLpChat
      };
      // Start handle Server side event from LP connector service
      yield handleEventsFromLivePerson(eventSourceOptions);
      const lpData = {
        messageType: MESSAGE_TYPE.OPEN,
        productId
      };
      const livePersonMessagePayload = {
        chatCustomerId,
        user: {
          firstName: lpUserFirstName,
          lastName: lpUserLastName
        },
        lpData,
        msgId: uuidV4()
      };
      const requestOptions = {
        url: submitMessageURL,
        headers: {}
      };
      const submitOPENMessageOptions = {
        requestOptions,
        livePersonMessagePayload,
        handleLivePersonOnMessageError
      };
      // Submit OPEN message to init the conversation with LP agent
      const {
        errorMessage
      } = yield submitMessageToLivePerson(submitOPENMessageOptions);
      setIsDisablingInputValue(false);
      const contentSeparatorMessage = {
        role: 'chatContentSeparator',
        content: 'Transfer to Live Agent',
        key: 'connectingToAgent'
      };
      // display the chat content separator
      setChatMessages([...chatMessages, contentSeparatorMessage]);
      setCachedMessages(contentSeparatorMessage);
      // Log the initiate agent event
      initiateAgentlog();
      if (errorMessage) {
        setErrorMessage(errorMessage);
      }
    }
  }), [isLivePersonEnabled, lpUserFirstName, lpUserLastName, chatMessages, isLivePersonSessionActive]);
};